import { z } from 'zod';
import { OwnerFooterSchema } from '../../owner/email.js';
import { OwnerThemeSchema } from '../../owner/theme.js';
/** Public (unauthenticated) slice of the default owner, needed before a user signs in */
export const DefaultOwnerInfoSchema = z.object({
    footer: OwnerFooterSchema.pick({ customerServicePhone: true }),
    theme: OwnerThemeSchema,
});
export const GetDefaultOwnerInfoApiSchema = {
    response: DefaultOwnerInfoSchema,
};
export const GetDefaultOwnerInfoResponseSchema = GetDefaultOwnerInfoApiSchema.response;
